<template>
  <section class="payment-view">
    <h2 class="payment-title">
      Оплата недоступна
    </h2>
    <div class="text-center">
      <icon-close style="max-width: 150px; max-height: 150px;" />
    </div>
    <div class="payment-description">
      Филиал не принимает оплату на точке: способы оплаты отключены в настройках филиала.
    </div>
    <div class="total">
      {{ total | amountWithCurrency }}
    </div>
    <large-btn
      class="primary-confirm-dialog_btn primary-confirm-dialog_btn__confirm"
      color="primary"
      height="64px"
      :uppercase="false"
      block
      @click="$emit('close')"
    >
      Закрыть
    </large-btn>
  </section>
</template>

<script>
  import IconClose from '@/components/icons/IconClose.vue'
  import LargeBtn from '@/components/ui/buttons/LargeBtn.vue'

  export default {
    name: 'PaymentNotAvailableView',
    components: { IconClose, LargeBtn },
    props: {
      total: {
        type: Number,
        default: () => null,
      },
    },
  }
</script>

<style lang="less" scoped>
.payment-view {
    padding: 15px 27px;
    height: 550px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .v-btn--block {
      flex-grow: 0;
    }
}
.payment-title {
    font-size: 26px;
    font-weight: 500;
    line-height: 1.2;
    letter-spacing: -0.01em;
    text-align: center;
    color: #111;
  }
.payment-description {
    font-size: 18px;
    line-height: 1.4;
    text-align: center;
    color: #6b6b6b;
  }
.total {
    color: #161616;
    font-size: 42px;
    text-align: center;
  }
</style>
